module.exports = __webpack_public_path__ + "assets/a1a749e89f578a49306ec2b055c073da.svg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/semantic/themes/default/assets/fonts/brand-icons.svg
// module id = 3646
// module chunks = 0